import React, { useState, useEffect, use } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { MdDeleteOutline } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import "../Inventory/Inventory.css";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "react-select";
import { IoIosSearch } from "react-icons/io";
import { components } from "react-select";
import { Autocomplete, TextField } from "@mui/material";
import Modal from "react-bootstrap/Modal";

export const DistributorCreateOrder = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [billingAddress, setBillingAddress] = useState({
    customerName: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    district: "",
    state: "",
    pincode: "",
    stateCode: "",
    gstin: "",
    pan_number: "",
  });
  const [shippingAddress, setShippingAddress] = useState({
    customerName: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    district: "",
    state: "",
    pincode: "",
    stateCode: "",
    // gstin: "",
  });
  const [additionalInfo, setAdditionalInfo] = useState({
    paymentType: "",
    paymentMode: "",
    agentReferralCode: "",
    invoiceNumber: "",
    invoiceDate: "",
    customerType: "",
  });
  // const [customerName, setCustomerName] = useState("");
  // const [phoneNumber, setPhoneNumber] = useState("");
  // const [email, setEmail] = useState("");
  // const [address, setAddress] = useState("");
  // const [city, setCity] = useState("");
  // const [district, setDistrict] = useState("");
  // const [state, setState] = useState("");
  // const [pincode, setPincode] = useState("");
  // const [stateCode, setStateCode] = useState("0");
  // const [gstin, setGstin] = useState("");
  // const [paymentType, setPaymentType] = useState("");
  // const [paymentMode, setPaymentMode] = useState("");
  // const [agentReferralCode, setAgentReferalCode] = useState("");
  // const [invoiceNumber, setInvoiceNumber] = useState("");
  // const [invoiceDate, setInvoiceDate] = useState("");
  // const [customerType, setCustomerType] = useState("");
  const [additionalNote, setAdditionalNote] = useState("");
  const [dropdownProductcode, setDropdownProductCode] = useState();
  const [priceType, setPriceType] = useState("");
  console.log("priceType", priceType);
  const [error, setError] = useState({});

  // search icon in product code
  const SearchDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <IoIosSearch size={16} color="#92959c" />
      </components.DropdownIndicator>
    );
  };

  const [addStockRow, setAddStockRow] = useState([
    {
      id: Date.now() + Math.random(),
      productCode: "",
      productId: "",
      product: "",
      // category: "",
      // uom: "",
      packageSize :"",
      hscode: "",
      currentStock: "",
      qty: "",
      // price: "",
      editablePrice: "",
      priceType: "",
      defaultPrice: "",
      subdistributorSellingPrice: "",
      retailPrice: "",
      subTotal: "",
      gstPercent: "",
      cgsg: "",
      totalAfterTax: "",
      discount: "",
      final: "",
    },
  ]);
  // Add stock  new row
  const handleAddStockRow = () => {
    setAddStockRow((prevRows) => [
      ...prevRows,
      {
        id: Date.now() + Math.random(), //it creates a unique ID based on the exact millisecond the row was added.
        productCode: "",
        productId: "",
        product: "",
        // category: "",
        // uom: "",
        packageSize:"",
        hscode: "",
        currentStock: "",
        qty: "",
        // price: "",
        editablePrice: "",
        priceType: "",
        defaultPrice: "",
        subdistributorSellingPrice: "",
        retailPrice: "",
        subTotal: "",
        gstPercent: "",
        cgsg: "",
        totalAfterTax: "",
        discount: "",
        final: "",
      },
    ]);
  };

  // Delete add stock row
  const handleDeleteStockRow = (id) => {
    setAddStockRow((prevRows) => prevRows.filter((row) => row.id !== id));
  };
  const totalQty = addStockRow.reduce(
    (sum, row) => sum + Number(row.qty || 0),
    0,
  );
  const totalValue = addStockRow.reduce(
    (sum, row) => sum + Number(row.total || 0),
    0,
  );

  const calculateRow = (row, updatedFields = {}) => {
    const updatedRow = { ...row, ...updatedFields };

    const qty = Number(updatedRow.qty || 0);

    const selectedPrice =
      updatedRow.editablePrice !== ""
        ? Number(updatedRow.editablePrice)
        : updatedRow.priceType === "default_cost_price"
          ? Number(updatedRow.defaultPrice || 0)
          : updatedRow.priceType === "subdistributor_selling_price"
            ? Number(updatedRow.subdistributorSellingPrice || 0)
            : updatedRow.priceType === "retail_selling_price"
              ? Number(updatedRow.retailPrice || 0)
              : 0;

    const subTotal = Number((qty * selectedPrice).toFixed(2));

    const gstPercent = Number(updatedRow.gstPercent || 0);
    const cgsg = Number(((gstPercent / 100) * subTotal).toFixed(2));

    const totalAfterTax = Number((subTotal + cgsg).toFixed(2));

    const discount = Number(updatedRow.discount || 0);
    const final = Number(
      (totalAfterTax - (discount / 100) * totalAfterTax).toFixed(2),
    );

    return {
      ...updatedRow,
      subTotal,
      cgsg,
      totalAfterTax,
      final,
    };
  };

  function handlePriceChange(rowId, value) {
    setAddStockRow((prev) =>
      prev.map((row) =>
        row.id === rowId ? calculateRow(row, { editablePrice: value }) : row,
      ),
    );
  }

  function handleQtyChange(rowId, value) {
    setAddStockRow((prev) =>
      prev.map((row) =>
        row.id === rowId ? calculateRow(row, { qty: value }) : row,
      ),
    );
  }

  function handleGstPercent(rowId, value) {
    setAddStockRow((prev) =>
      prev.map((row) =>
        row.id === rowId ? calculateRow(row, { gstPercent: value }) : row,
      ),
    );
  }
  function handleDiscountChange(rowId, value) {
    setAddStockRow((prev) =>
      prev.map((row) =>
        row.id === rowId ? calculateRow(row, { discount: value }) : row,
      ),
    );
  }
  // function handleQtyChange(rowId, value) {
  //   const qty = value;

  //   setAddStockRow((prevRows) =>
  //     prevRows.map((row) => {
  //       if (row.id !== rowId) return row;
  //       let selectedPrice = row.editablePrice
  //         ? Number(row.editablePrice)
  //         : row.priceType === "default_cost_price"
  //           ? Number(row.defaultPrice || 0)
  //           : row.priceType === "subdistributor_selling_price"
  //             ? Number(row.subdistributorSellingPrice || 0)
  //             : row.priceType === "retail_selling_price"
  //               ? Number(row.retailPrice || 0)
  //               : 0;
  //       const subTotal = Number((qty * selectedPrice).toFixed(2));

  //       const gstPercent = Number(row.gstPercent || 0);
  //       const cgsg = Number(((gstPercent / 100) * subTotal).toFixed(2));

  //       const totalAfterTax = Number((subTotal + cgsg).toFixed(2));

  //       const discount = Number(row.discount || 0);
  //       const discountAmount = (discount / 100) * totalAfterTax;

  //       const final = Number((totalAfterTax - discountAmount).toFixed(2));
  //       return {
  //         ...row,

  //         // subTotal: Number((qty * selectedPrice).toFixed(2)),
  //         qty,
  //         subTotal,
  //         gstPercent,
  //         cgsg,
  //         totalAfterTax,
  //         discount,
  //         final,
  //       };
  //     }),
  //   );
  // }

  // function handleGstPercent(rowId, value) {
  //   const gstPercent = value;

  //   setAddStockRow((prevRows) =>
  //     prevRows.map((row) => {
  //       if (row.id !== rowId) return row;
  //       const subTotal = Number(row.subTotal || 0);
  //       const cgsg = Number(((gstPercent / 100) * subTotal).toFixed(2));
  //       const totalAfterTax = Number((subTotal + cgsg).toFixed(2));

  //       const discount = Number(row.discount || 0);
  //       const final = Number(
  //         (totalAfterTax - (discount / 100) * totalAfterTax).toFixed(2),
  //       );
  //       return {
  //         ...row,
  //         gstPercent,
  //         cgsg,
  //         totalAfterTax,
  //         final,
  //       };
  //     }),
  //   );
  // }

  // function handleDiscountChange(rowId, value) {
  //   const discount = value;
  //   setAddStockRow((prevRows) =>
  //     prevRows.map((row) => {
  //       if (row.id !== rowId) return row;

  //       const totalAfterTax = Number(row.totalAfterTax || 0);

  //       const discountAmount = (discount / 100) * totalAfterTax;
  //       const finalAmount = totalAfterTax - discountAmount;

  //       return {
  //         ...row,
  //         discount,
  //         // final: totalAfterTax - Number(discount / 100) * totalAfterTax,
  //         final: Number(finalAmount.toFixed(2)),
  //       };
  //     }),
  //   );
  // }

  async function fetchProductDetails(rowId, productId) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `inventory/product/${productId}`,
      );
      if (response.data.status === "success" || response.status === 200) {
        const details = response.data.data;

        setAddStockRow((prevRows) =>
          prevRows.map((row) =>
            row.id === rowId // only update the matching row here  both row.id===rowId is from frontend
              ? {
                  ...row,
                  backendId: details.id,
                  productId: productId,
                  // productCode: productCode,
                  productCode: details.product_code,
                  product: details.product_name || "",
                  // category: details.category || "",
                  // uom: details.uom || "",
                  packageSize : details.package_size || "",
                  hscode: details.hs_code || "",
                  // defaultCost: details.default_cost_price || "",
                  currentStock: details.current_stock ?? "0",
                  qty: row.qty || "",
                  // price: details.default_cost_price || "",
                  defaultPrice: details.default_cost_price || "",
                  subdistributorSellingPrice:
                    details.subdistributor_selling_price || "",
                  retailPrice: details.retail_selling_price || "",

                  // total: (row.qty || 1) * details.default_cost_price,
                  // reset fields whenever product code or product name change
                  qty: "",
                  editablePrice: "",
                  priceType: "",
                  subTotal: "",
                  gstPercent: "",
                  cgsg: "",
                  totalAfterTax: "",
                  discount: "",
                  final: "",
                }
              : row,
          ),
        );
        console.log(
          response.data.message || "Product details fetched successfully",
        );
      }
    } catch (error) {
      console.log("Failed to fetch product details", error);
      toast.error(
        error.response?.data?.message || "Failed to fetch product details",
      );
    } finally {
      setLoading(false);
    }
  }

  async function LoadDropdownProductcode() {
    try {
      const response = await axiosInstance.get(
        "/inventory/distributor/product-code/",
      );
      if (response.data.status === "success" || response.status === 200) {
        setDropdownProductCode(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to load dropdown");
      console.log("Failed to load dropdown");
    }
  }
  const productCodeOptions = dropdownProductcode?.map((item) => ({
    // value: item.product_code,
    value: item.id,
    label: item.product_code,
  }));
  const productNameOptions = dropdownProductcode?.map((item) => ({
    // value: item.product_code,
    value: item.id,
    label: item.product_name,
  }));

  useEffect(() => {
    LoadDropdownProductcode();
  }, []);

  async function handleSave() {
    try {
      // const newErrors = {};
      const newErrors = {
        billingAddress: {},
        shippingAddress: {},
        additionalInfo: {},
      }; // for showing erros separetly for each field

      if (!billingAddress.phoneNumber) {
        newErrors.billingAddress.phoneNumber = "Phone number is required";
      } else if (!/^\d{10}$/.test(billingAddress.phoneNumber)) {
        newErrors.billingAddress.phoneNumber =
          "Phone number must be exactly 10 digits";
      }

      if (!billingAddress.customerName) {
        newErrors.billingAddress.customerName = "Customer name is required";
      }

      if (!shippingAddress.customerName) {
        newErrors.shippingAddress.customerName = "Customer name is required";
      }
      if (!shippingAddress.phoneNumber) {
        newErrors.shippingAddress.phoneNumber = "Phone number is required";
      } else if (!/^\d{10}$/.test(shippingAddress.phoneNumber)) {
        newErrors.shippingAddress.phoneNumber =
          "Phone number must be exactly 10 digits";
      }

      if (!additionalInfo.paymentType) {
        newErrors.additionalInfo.paymentType = "Payment type is required";
      }
      if (!additionalInfo.paymentMode) {
        newErrors.additionalInfo.paymentMode = "Payment Mode is required";
      }
      if (!additionalInfo.invoiceNumber) {
        newErrors.additionalInfo.invoiceNumber = "Invoice Number is required";
      }
      if (!additionalInfo.invoiceDate) {
        newErrors.additionalInfo.invoiceDate = "Invoice Date is required";
      }
      if (!additionalInfo.customerType) {
        newErrors.additionalInfo.customerType = "Customer type is required";
      }

      // setError(newErrors);

      // if (Object.keys(newErrors).length > 0) return;
      const hasErrors =
        Object.keys(newErrors.billingAddress).length > 0 ||
        Object.keys(newErrors.shippingAddress).length > 0 ||
        Object.keys(newErrors.additionalInfo).length > 0;

      if (hasErrors) {
        setError(newErrors);
        return;
      }

      setLoading(true);

      const products = addStockRow.map((item) => {
        // const selectedPrice =
        //   item.priceType === "default_cost_price"
        //     ? item.defaultPrice
        //     : item.priceType === "subdistributor_selling_price"
        //       ? item.subdistributorSellingPrice
        //       : item.priceType === "retail_selling_price"
        //         ? item.retailPrice
        //         : 0;
        const selectedPrice = item.editablePrice
          ? Number(item.editablePrice)
          : item.priceType === "default_cost_price"
            ? item.defaultPrice
            : item.priceType === "subdistributor_selling_price"
              ? item.subdistributorSellingPrice
              : item.priceType === "retail_selling_price"
                ? item.retailPrice
                : 0;

        return {
          product_id: item.backendId,
          price_type: item.priceType,
          qty: item.qty,
          price: selectedPrice,
          total: item.subTotal,
          gst: item.gstPercent,
          cgst_sgst: item.cgsg,
          total_after_tax: item.totalAfterTax,
          discount: item.discount,
          final: item.final,
        };
      });
      const payload = {
        // billing address
        customer_name: billingAddress.customerName?.trim() || "",
        phone_number: billingAddress.phoneNumber,
        email: billingAddress.email,
        address: billingAddress.address,
        city: billingAddress.city,
        state: billingAddress.state,
        state_code: billingAddress.stateCode,
        gstin: billingAddress.gstin,
        district: billingAddress.district,
        pincode: billingAddress.pincode,
        pan_number: billingAddress.pan_number,
        // shipping address
        shipping_name: shippingAddress.customerName?.trim() || "",
        shipping_phone: shippingAddress.phoneNumber,
        shipping_email: shippingAddress.email,
        shipping_address: shippingAddress.address,
        shipping_city: shippingAddress.city,
        shipping_state: shippingAddress.state,
        shipping_state_code: shippingAddress.stateCode,
        // gstin: shippingAddress.gstin,
        shipping_district: shippingAddress.district,
        shipping_pincode: shippingAddress.pincode,
        // additional info
        payment_type: additionalInfo.paymentType,
        payment_mode: additionalInfo.paymentMode,
        agent_referral_code: additionalInfo.agentReferralCode,
        invoice_number: additionalInfo.invoiceNumber,
        invoice_date: additionalInfo.invoiceDate,
        customer_type_id: additionalInfo.customerType,
        // table data
        products: products,
        additional_notes: additionalNote,
      };
      const response = await axiosInstance.post(
        "distributor/create-order/",
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response?.data?.message || "submitted successfully");
        console.log("submitted successfully");
        setError("");
        setTimeout(() => {
          navigate("/state-orders");
        }, 2000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to submit");
      console.log("Failed to submit");
    } finally {
      setLoading(false);
    }
  }
  // suggested numbers

  const [phoneSuggestions, setPhoneSuggestions] = useState([]);
  // const [isNotAvailable, setIsNotAvailable] = useState(null);
  async function fetchPhoneSuggestions(value) {
    try {
      const config = {
        params: {
          mobile: value,
        },
      };
      const response = await axiosInstance.get(
        "/customers/search-by-mobile/",
        config,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setPhoneSuggestions(response.data.data || []);
        // setIsNotAvailable(response.data.data.length === 0);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "failed to fetch phone No.suggestions",
      );
      console.log("failed to fetch phone No.suggestions");
    }
  }

  useEffect(() => {
    if (billingAddress.phoneNumber.length < 2) {
      setPhoneSuggestions([]);
      return;
    }

    const delay = setTimeout(() => {
      fetchPhoneSuggestions(billingAddress.phoneNumber);
    }, 400);

    return () => clearTimeout(delay);
  }, [billingAddress.phoneNumber]);

  // customer details prefill

  const [customerData, setCustomerData] = useState({});
  async function fetchCustomerDetails(value) {
    try {
      setLoading(true);
      const config = {
        params: {
          mobile: value,
        },
      };
      const response = await axiosInstance.get(
        "/customers/customer-by-mobile/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setCustomerData(response.data?.data);
        // toast.success(
        //   response.data.message || "fetch customer details successfully!",
        // );
        console.log("fetch customer details successfully!");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "failed to fetch customer details",
      );
      console.log("failed to fetch customer details");
    } finally {
      setLoading(false);
    }
  }
  // fetch data only suggested number available
  // useEffect(() => {
  //   if (billingAddress.phoneNumber.length === 10 && isNotAvailable === false) {
  //     fetchCustomerDetails(billingAddress.phoneNumber);
  //   }
  // }, [billingAddress.phoneNumber, isNotAvailable]);

  useEffect(() => {
    if (
      billingAddress?.phoneNumber &&
      billingAddress.phoneNumber.length === 10
    ) {
      fetchCustomerDetails(billingAddress.phoneNumber);
    }
  }, [billingAddress.phoneNumber]);

  useEffect(() => {
    if (customerData && Object.keys(customerData).length > 0) {
      setBillingAddress({
        customerName: customerData.customer_name || "",
        phoneNumber: customerData.mobile || "",
        email: customerData.email || "",
        address: customerData.address || "",
        city: customerData.city || "",
        district: customerData.district || "",
        state: customerData.state || "",
        pincode: customerData.pincode || "",
        stateCode: customerData.state_code || "0",
        gstin: customerData.gstin || "",
        pan_number: customerData.pan_number || "",
      });
    }
    // else {
    //   setBillingAddress({
    //     customerName: "",
    //     phoneNumber: "",
    //     email: "",
    //     address: "",
    //     city: "",
    //     district: "",
    //     state: "",
    //     pincode: "",
    //     stateCode: "0",
    //     gstin: "",
    //   });
    // }
  }, [customerData]);

  const [sameAsBilling, setSameAsBilling] = useState(false);
  const initialShippingAddress = {
    customerName: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    district: "",
    state: "",
    pincode: "",
    stateCode: "",
    // gstin: "",
  };

  const handleSameAddress = (e) => {
    const checked = e.target.checked;
    setSameAsBilling(checked);

    if (checked) {
      setShippingAddress(billingAddress);
    } else {
      setShippingAddress(initialShippingAddress); // for uncheck clear
    }
  };
  // Keep Sync When Billing Changes
  useEffect(() => {
    if (sameAsBilling) {
      // setShippingAddress(billingAddress);
      setShippingAddress({ ...billingAddress });
    }
  }, [billingAddress, sameAsBilling]);

  // customer type dropdown
  const [customerDropdown, setCustomerDropdown] = useState([]);
  async function fetchCustomerTypeDropdwon() {
    try {
      const response = await axiosInstance.get("/customer-types/");
      if (response.data.status === "Success" || response.status === 200) {
        setCustomerDropdown(response.data?.data);
        console.log(response.data.message);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch customer dropdown data",
      );
      console.log("Failed to fetch customer dropdown data");
    }
  }

  useEffect(() => {
    fetchCustomerTypeDropdwon();
  }, []);
  // customer type modal
  const [customershow, setCustomerShow] = useState(false);

  const handleCustomerClose = () => setCustomerShow(false);
  const handleCustomerShow = () => {
    setCustomerShow(true);
    //  handleAddClose();
  };

  const [customerTypeName, setCustomerTypeName] = useState("");
  async function handleCustomerSubmit() {
    try {
      setLoading(true);
      const payload = {
        name: customerTypeName,
      };
      const response = await axiosInstance.post("/customer-types/", payload);
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "Customer type added");
        handleCustomerClose();
        fetchCustomerTypeDropdwon();
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to add customer type");
      console.log("Failed to add customer type");
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />

      <div className="inventoryContainer">
        <div className="container">
          <div className="d-flex gap-1 mb-2">
            <span className="me-2">
              <Link to="/state-orders" style={{ color: "black" }}>
                <FaArrowLeftLong />
              </Link>
            </span>
            <div className="addModalTitle">Create New Order</div>
          </div>

          {/* Reference No & Date */}
          <div className="AddressTitle">Billing Address :</div>
          <div className="bulkAddGrid">
            <div>
              <label>
                Phone Number <span className="text-danger">*</span>
                <label>
                  (Select a number from suggestions to auto-fill details)
                </label>
              </label>
              <Autocomplete
                freeSolo
                options={phoneSuggestions || []}
                inputValue={billingAddress.phoneNumber || ""}
                getOptionLabel={(option) => option?.mobile || ""}
                onInputChange={(e, value) => {
                  const cleaned = value.replace(/\D/g, "").slice(0, 10);
                  // setPhoneNumber(cleaned);
                  setBillingAddress((prev) => ({
                    ...prev,
                    phoneNumber: cleaned,

                    // clear old customer data immediately
                    customerName: "",
                    email: "",
                    address: "",
                    city: "",
                    district: "",
                    state: "",
                    pincode: "",
                    stateCode: "0",
                    gstin: "",
                    pan_number: "",
                  }));
                  setError((prev) => ({
                    ...prev,
                    billingAddress: {
                      ...prev.billingAddress,
                      phoneNumber: "",
                    },
                  }));
                }}
                onChange={(e, value) => {
                  if (value?.mobile) {
                    // setPhoneNumber(value.mobile);
                    setBillingAddress((prev) => ({
                      ...prev,
                      phoneNumber: value.mobile,
                    }));
                    fetchCustomerDetails(value.mobile);
                  }
                }}
                sx={{
                  "& .MuiAutocomplete-popupIndicator": { display: "none" },
                  "& .MuiAutocomplete-clearIndicator": { display: "none" },
                }}
                renderInput={(params) => (
                  <div ref={params.InputProps.ref}>
                    <input
                      {...params.inputProps}
                      type="text"
                      placeholder="Enter Phone Number"
                      maxLength={10}
                      // className="formInput"
                    />
                  </div>
                )}
              />
              {/* {isNotAvailable && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  Customer with this phone number not available
                </div>
              )} */}

              {/* <input
                type="text"
                placeholder="Enter Phone Number"
                value={phoneNumber}
                maxLength={10}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // only digits
                  setPhoneNumber(value);
                  setError(""); // clear error while typing
                }}
                onBlur={() => fetchCustomerDetails()}
              /> */}
              {error?.billingAddress?.phoneNumber && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  {error?.billingAddress?.phoneNumber}
                </div>
              )}
            </div>
            <div className="mt-4">
              <label>
                Customer Name
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Customer Name"
                value={billingAddress.customerName}
                // onChange={(e) => setCustomerName(e.target.value)}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    customerName: e.target.value,
                  }))
                }
              />
              {error?.billingAddress?.customerName && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  {error.billingAddress.customerName}
                </div>
              )}
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>Email</label>
              <input
                type="text"
                placeholder="Enter Email"
                value={billingAddress.email}
                // onChange={(e) => setEmail(e.target.value)}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }))
                }
              />
            </div>

            <div>
              <label>Address</label>
              <input
                type="text"
                placeholder="Enter Address"
                value={billingAddress.address}
                // onChange={(e) => setAddress(e.target.value)}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    address: e.target.value,
                  }))
                }
              />
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>City</label>
              <input
                type="text"
                placeholder="Enter City"
                value={billingAddress.city}
                // onChange={(e) => setCity(e.target.value)}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    city: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <label>District</label>
              <input
                type="text"
                placeholder="Enter District"
                value={billingAddress.district}
                // onChange={(e) => setDistrict(e.target.value)}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    district: e.target.value,
                  }))
                }
              />
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>State</label>
              <input
                type="text"
                placeholder="Enter State"
                value={billingAddress.state}
                // onChange={(e) => setState(e.target.value)}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    state: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <label>Pin Code</label>
              <input
                type="text"
                placeholder="Enter Pincode"
                value={billingAddress.pincode}
                // onChange={(e) => setPincode(e.target.value)}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    pincode: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          <div className="bulkAddGrid">
            <div>
              <label>State Code</label>
              <input
                type="text"
                placeholder="Enter State Code"
                value={billingAddress.stateCode}
                // onChange={(e) => setStateCode(e.target.value)}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    stateCode: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <label>GSTIN</label>
              <input
                type="text"
                placeholder="Enter GSTIN"
                value={billingAddress.gstin}
                // onChange={(e) => setGstin(e.target.value)}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    gstin: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <label>Pan Number</label>
              <input
                type="text"
                placeholder="Enter Pan Number"
                value={billingAddress.pan_number}
                onChange={(e) =>
                  setBillingAddress((prev) => ({
                    ...prev,
                    pan_number: e.target.value,
                  }))
                }
              />
            </div>
          </div>
          {/* shipping address  */}
          <div className="d-flex justify-content-between">
            <div className="AddressTitle">Shipping Address :</div>
            <div className=" sameAddressText">
              <input
                type="checkbox"
                checked={sameAsBilling}
                onChange={handleSameAddress}
              />
              <span className="ms-2">Same as Billing Address</span>
            </div>
          </div>

          <div className="bulkAddGrid">
            <div>
              <label>
                Customer Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Customer Name"
                value={shippingAddress.customerName}
                // onChange={(e) => setCustomerName(e.target.value)}
                onChange={(e) =>
                  setShippingAddress((prev) => ({
                    ...prev,
                    customerName: e.target.value,
                  }))
                }
              />
              {error?.shippingAddress?.customerName && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  {error?.shippingAddress?.customerName}
                </div>
              )}
            </div>
            <div>
              <label>
                Phone Number <span className="text-danger">*</span>
              </label>
              {/* <Autocomplete
                freeSolo
                options={phoneSuggestions || []}
                inputValue={phoneNumber}
                getOptionLabel={(option) => option?.mobile || ""}
                onInputChange={(e, value) => {
                  const cleaned = value.replace(/\D/g, "").slice(0, 10);
                  setPhoneNumber(cleaned);
                  setError((prev) => ({
                    ...prev,
                    phoneNumber: "",
                  }));
                }}
                onChange={(e, value) => {
                  if (value?.mobile) {
                    setPhoneNumber(value.mobile);
                    fetchCustomerDetails(value.mobile);
                  }
                }}
                sx={{
                  "& .MuiAutocomplete-popupIndicator": { display: "none" },
                  "& .MuiAutocomplete-clearIndicator": { display: "none" },
                }}
                renderInput={(params) => (
                  <div ref={params.InputProps.ref}>
                    <input
                      {...params.inputProps}
                      type="text"
                      placeholder="Enter Phone Number"
                      maxLength={10}
                      // className="formInput"
                    />
                  </div>
                )}
              /> */}

              <input
                type="text"
                placeholder="Enter Phone Number"
                value={shippingAddress.phoneNumber}
                maxLength={10}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // only digits
                  setShippingAddress((prev) => ({
                    ...prev,
                    phoneNumber: value,
                  }));
                  setError((prev) => ({
                    ...prev,
                    shippingAddress: {
                      ...prev.shippingAddress,
                      phoneNumber: "",
                    },
                  })); // clear error while typing
                }}
                // onBlur={() => fetchCustomerDetails()}
              />
              {error?.shippingAddress?.phoneNumber && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  {error?.shippingAddress?.phoneNumber}
                </div>
              )}
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>Email</label>
              <input
                type="email"
                placeholder="Enter Email"
                value={shippingAddress.email}
                // onChange={(e) => setEmail(e.target.value)}
                onChange={(e) =>
                  setShippingAddress((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }))
                }
              />
            </div>

            <div>
              <label>Address</label>
              <input
                type="text"
                placeholder="Enter Address"
                value={shippingAddress.address}
                // onChange={(e) => setAddress(e.target.value)}
                onChange={(e) =>
                  setShippingAddress((prev) => ({
                    ...prev,
                    address: e.target.value,
                  }))
                }
              />
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>City</label>
              <input
                type="text"
                placeholder="Enter City"
                value={shippingAddress.city}
                // onChange={(e) => setCity(e.target.value)}
                onChange={(e) =>
                  setShippingAddress((prev) => ({
                    ...prev,
                    city: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <label>District</label>
              <input
                type="text"
                placeholder="Enter District"
                value={shippingAddress.district}
                // onChange={(e) => setDistrict(e.target.value)}
                onChange={(e) =>
                  setShippingAddress((prev) => ({
                    ...prev,
                    district: e.target.value,
                  }))
                }
              />
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>State</label>
              <input
                type="text"
                placeholder="Enter State"
                value={shippingAddress.state}
                // onChange={(e) => setState(e.target.value)}
                onChange={(e) =>
                  setShippingAddress((prev) => ({
                    ...prev,
                    state: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <label>Pin Code</label>
              <input
                type="text"
                placeholder="Enter Pincode"
                value={shippingAddress.pincode}
                // onChange={(e) => setPincode(e.target.value)}
                onChange={(e) =>
                  setShippingAddress((prev) => ({
                    ...prev,
                    pincode: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          <div className="bulkAddGrid">
            <div>
              <label>State Code</label>
              <input
                type="text"
                placeholder="Enter State Code"
                value={shippingAddress.stateCode}
                // onChange={(e) => setStateCode(e.target.value)}
                onChange={(e) =>
                  setShippingAddress((prev) => ({
                    ...prev,
                    stateCode: e.target.value,
                  }))
                }
              />
            </div>
            {/* <div>
              <label>GSTIN</label>
              <input
                type="text"
                placeholder="Enter GSTIN"
                value={shippingAddress.gstin}
                // onChange={(e) => setGstin(e.target.value)}
                onChange={(e) =>
                  setShippingAddress((prev) => ({
                    ...prev,
                    gstin: e.target.value,
                  }))
                }
              />
            </div> */}
          </div>

          <div className="AddressTitle">Additional Information :</div>
          <div className="bulkAddGrid">
            <div>
              <label>
                Payment Type <span className="text-danger">*</span>
              </label>
              <select
                value={additionalInfo.paymentType}
                onChange={(e) => {
                  // setPaymentType(e.target.value);
                  setAdditionalInfo((prev) => ({
                    ...prev,
                    paymentType: e.target.value,
                  }));
                  setError((prev) => ({
                    ...prev,
                    additionalInfo: {
                      ...prev.additionalInfo,
                      paymentType: "",
                    },
                  }));
                }}
              >
                <option value={""} disabled selected>
                  Select
                </option>
                <option value="debit">Debit</option>
                <option value="credit">Credit</option>
              </select>
              {error?.additionalInfo?.paymentType && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  {error?.additionalInfo?.paymentType}
                </div>
              )}
            </div>
            <div>
              <label>
                Payment Mode <span className="text-danger">*</span>
              </label>
              <select
                value={additionalInfo.paymentMode}
                onChange={(e) => {
                  // setPaymentMode(e.target.value);
                  setAdditionalInfo((prev) => ({
                    ...prev,
                    paymentMode: e.target.value,
                  }));
                  setError((prev) => ({
                    ...prev,
                    additionalInfo: {
                      ...prev.additionalInfo,
                      paymentMode: "",
                    },
                  }));
                }}
              >
                <option value={""} disabled selected>
                  Select
                </option>
                <option value="upi">UPI</option>
                <option value="cash">Cash</option>
              </select>
              {error?.additionalInfo?.paymentMode && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  {error?.additionalInfo?.paymentMode}
                </div>
              )}
            </div>
          </div>

          <div className="bulkAddGrid">
            <div>
              <label>Agent Referral Code</label>
              <input
                type="text"
                placeholder="Enter Agent Referral Code"
                value={additionalInfo.agentReferralCode}
                // onChange={(e) => setAgentReferalCode(e.target.value)}
                onChange={(e) =>
                  setAdditionalInfo((prev) => ({
                    ...prev,
                    agentReferralCode: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <label>
                Invoice Number <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Invoice Number"
                value={additionalInfo.invoiceNumber}
                onChange={(e) => {
                  // setInvoiceNumber(e.target.value);
                  setAdditionalInfo((prev) => ({
                    ...prev,
                    invoiceNumber: e.target.value,
                  }));
                  setError((prev) => ({
                    ...prev,
                    additionalInfo: {
                      ...prev.additionalInfo,
                      invoiceNumber: "",
                    },
                  }));
                }}
              />
              {error?.additionalInfo?.invoiceNumber && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  {error?.additionalInfo?.invoiceNumber}
                </div>
              )}
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>
                Invoice Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                value={additionalInfo.invoiceDate}
                onChange={(e) => {
                  // setInvoiceDate(e.target.value);
                  setAdditionalInfo((prev) => ({
                    ...prev,
                    invoiceDate: e.target.value,
                  }));
                  setError((prev) => ({
                    ...prev,
                    additionalInfo: {
                      ...prev.additionalInfo,
                      invoiceDate: "",
                    },
                  }));
                }}
              />
              {error?.additionalInfo?.invoiceDate && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  {error?.additionalInfo?.invoiceDate}
                </div>
              )}
            </div>
            <div>
              <div className="d-flex justify-content-between">
                <label>
                  Customer Type <span className="text-danger">*</span>
                </label>
                <div onClick={handleCustomerShow} className="addCategoryText">
                  Add Customer Type
                </div>
              </div>
              <select
                // onChange={(e) => setCustomerType(e.target.value)}
                // name="customer_type_id"
                value={additionalInfo.customerType}
                onChange={(e) =>
                  setAdditionalInfo((prev) => ({
                    ...prev,
                    customerType: e.target.value,
                  }))
                }
              >
                <option value={""} selected disabled>
                  Select
                </option>

                {customerDropdown.length > 0 ? (
                  customerDropdown.map((cus) => (
                    <option value={cus.id}>{cus.name}</option>
                  ))
                ) : (
                  <option>Data not available</option>
                )}
              </select>

              {error?.additionalInfo?.customerType && (
                <div style={{ fontSize: "14px", color: "red" }}>
                  {error?.additionalInfo?.customerType}
                </div>
              )}
            </div>
          </div>

          {/* Table */}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper} style={{ marginTop: "40px" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell sx={{ minWidth: 150 }}>Product Code</TableCell>
                    <TableCell align="left" sx={{ minWidth: 200 }}>
                      Product Name
                    </TableCell>

                    {/* <TableCell align="left" sx={{ minWidth: 80 }}>
                      UOM
                    </TableCell> */}
                    <TableCell align="left" sx={{minWidth:80}}>Package Size</TableCell>
                    <TableCell align="left" sx={{ minWidth: 120 }}>
                      HSN Code
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 120 }}>
                      Price Type
                    </TableCell>

                    <TableCell align="left" sx={{ minWidth: 120 }}>
                      Price/Unit (₹)
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 150 }}>
                      Current Stock
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 100 }}>
                      Qty
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 140 }}>
                      Total Price
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 100 }}>
                      GST %
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 140 }}>
                      CGST + SGST
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 160 }}>
                      Total After Tax
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 120 }}>
                      Discount
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 160 }}>
                      Final Total
                    </TableCell>
                    <TableCell align="left" sx={{ minWidth: 100 }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {addStockRow.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                      className="dashboardTableBody"
                    >
                      {/* <TableCell align="left">
                        <select
                          className="addModalQtySelect"
                          value={row.productCode}
                          onChange={(e) => {
                            fetchProductDetails(row.id, e.target.value);
                          }}
                        >
                          <option value={""} selected disabled>
                            Select
                          </option>
                          {dropdownProductcode?.map((drop) => (
                            <option value={drop.product_code}>
                              {drop.product_code}
                            </option>
                          ))}
                        </select>
                      </TableCell> */}
                      <TableCell align="left" style={{ minWidth: "180px" }}>
                        <Select
                          className="productCodeSelect"
                          classNamePrefix="select"
                          options={productCodeOptions}
                          placeholder="Search"
                          // value={
                          //   row.productCode
                          //     ? {
                          //         value: row.productCode,
                          //         label: row.productCode,
                          //       }
                          //     : null
                          // }
                          value={
                            row.productId
                              ? {
                                  value: row.productId,
                                  label: row.productCode,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            fetchProductDetails(
                              row.id,
                              selected?.value,
                              selected?.label,
                            )
                          }
                          isSearchable={true}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          components={{
                            DropdownIndicator: SearchDropdownIndicator, // 🔍 replace caret
                          }}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              boxShadow: "none", // remove blue glow
                              borderColor: "#92959c",
                              "&:hover": { borderColor: "#92959c" },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: 4,
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                          }}
                        />
                      </TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          width: "200px",
                          minWidth: "200px",
                        }}
                      >
                        <Select
                          className="productCodeSelect"
                          classNamePrefix="select"
                          options={productNameOptions}
                          placeholder="Search"
                          // value={
                          //   row.productCode
                          //     ? {
                          //         value: row.productCode,
                          //         label: row.productCode,
                          //       }
                          //     : null
                          // }
                          value={
                            row.productId
                              ? {
                                  value: row.productId,
                                  label: row.product,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            fetchProductDetails(row.id, selected?.value)
                          }
                          isSearchable={true}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          components={{
                            DropdownIndicator: SearchDropdownIndicator, // 🔍 replace caret
                          }}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              boxShadow: "none", // remove blue glow
                              borderColor: "#92959c",
                              "&:hover": { borderColor: "#92959c" },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: 4,
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                          }}
                        />
                        {/* {row.product || "---"} */}
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.uom}
                            placeholder="UOM"
                          />
                        </span> */}
                        {/* {row.uom || "---"} */}
                        {row.packageSize || "---"}
                      </TableCell>
                      <TableCell align="left">{row.hscode || "---"}</TableCell>

                      <TableCell align="left">
                        {/* <select
                          className="addModalQtySelect"
                          value={priceType}
                          onChange={(e) => {
                            setPriceType(e.target.value);
                          }}
                        > */}
                        <select
                          className="addModalQtySelect"
                          value={row.priceType}
                          // onChange={(e) => {
                          //   const value = e.target.value;

                          //   setAddStockRow((prev) =>
                          //     prev.map((r) =>
                          //       r.id === row.id
                          //         ? { ...r, priceType: value }
                          //         : r,
                          //     ),
                          //   );
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;

                            setAddStockRow((prev) =>
                              prev.map((r) => {
                                if (r.id !== row.id) return r;

                                let newPrice = "";

                                if (value === "default_cost_price") {
                                  newPrice = r.defaultPrice;
                                } else if (
                                  value === "subdistributor_selling_price"
                                ) {
                                  newPrice = r.subdistributorSellingPrice;
                                } else if (value === "retail_selling_price") {
                                  newPrice = r.retailPrice;
                                }

                                // call calculateRow
                                return calculateRow(r, {
                                  priceType: value,
                                  editablePrice: newPrice,
                                });
                              }),
                            );
                          }}
                        >
                          <option value={""} selected disabled>
                            Select
                          </option>

                          <option value={"default_cost_price"}>
                            Default Price
                          </option>
                          <option value={"subdistributor_selling_price"}>
                            Subdistributor price
                          </option>
                          <option value={"retail_selling_price"}>
                            Retail Price
                          </option>
                        </select>
                      </TableCell>

                      {/* <TableCell align="left">
                        {row.priceType === "default_cost_price"
                          ? row.defaultPrice
                          : row.priceType === "subdistributor_selling_price"
                            ? row.subdistributorSellingPrice
                            : row.priceType === "retail_selling_price"
                              ? row.retailPrice
                              : "---"}
                      </TableCell> */}
                      <TableCell align="left">
                        <span className="addModalQtyInput">
                          <input
                            type="number"
                            placeholder="Price"
                            value={
                              row.editablePrice !== ""
                                ? row.editablePrice
                                : row.priceType === "default_cost_price"
                                  ? row.defaultPrice
                                  : row.priceType ===
                                      "subdistributor_selling_price"
                                    ? row.subdistributorSellingPrice
                                    : row.priceType === "retail_selling_price"
                                      ? row.retailPrice
                                      : ""
                            }
                            // onChange={(e) => {
                            //   const value = e.target.value;
                            //   setAddStockRow((prev) =>
                            //     prev.map((r) =>
                            //       r.id === row.id
                            //         ? { ...r, editablePrice: value }
                            //         : r,
                            //     ),
                            //   );
                            // }}
                            onChange={(e) =>
                              handlePriceChange(row.id, e.target.value)
                            }
                          />
                        </span>
                      </TableCell>
                      <TableCell align="left">
                        {row.currentStock || 0}
                      </TableCell>
                      <TableCell align="left">
                        <span className="addModalQtyInput">
                          <input
                            type="number"
                            value={row.qty}
                            placeholder="Qty"
                            onChange={(e) =>
                              handleQtyChange(row.id, e.target.value)
                            }
                          />
                        </span>
                      </TableCell>

                      <TableCell align="left">{row.subTotal || 0}</TableCell>
                      <TableCell align="left">
                        <span className="addModalQtyInput">
                          <input
                            type="number"
                            value={row.gstPercent}
                            placeholder="GST"
                            onChange={(e) =>
                              handleGstPercent(row.id, e.target.value)
                            }
                          />
                        </span>
                      </TableCell>
                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.total}
                          placeholder="Total"
                        />
                      </span> */}
                        {row.cgsg || 0}
                      </TableCell>
                      <TableCell align="left">
                        {row.totalAfterTax || 0}
                      </TableCell>
                      <TableCell align="left">
                        <span className="addModalQtyInput">
                          <input
                            type="number"
                            value={row.discount}
                            placeholder="Discount"
                            onChange={(e) =>
                              handleDiscountChange(row.id, e.target.value)
                            }
                          />
                        </span>
                      </TableCell>
                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.total}
                          placeholder="Total"
                        />
                      </span> */}
                        {row.final || 0}
                      </TableCell>

                      <TableCell align="left">
                        <MdDeleteOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeleteStockRow(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* Add Row Button */}
          <div
            className="addRowText"
            onClick={handleAddStockRow}
            style={{ cursor: "pointer", marginTop: "10px" }}
          >
            + Add Row
          </div>

          {/* Totals */}
          {/* <div className="addModalTotalContainer">
            <div>
              <div className="addModalContent">
                <span>Total Products Received(Qty):</span>
                <span>{totalQty} nos</span>
              </div>
              <div className="addModalContent">
                <span>Total Value:</span>
                <span>₹{totalValue.toLocaleString()}</span>
              </div>
            </div>
          </div> */}

          {/* Notes */}
          <div className="bulkAddTextGrid">
            <div>
              <label>Additional Notes</label>
            </div>
            <div>
              <textarea
                placeholder="Type here"
                rows={4}
                value={additionalNote}
                onChange={(e) => setAdditionalNote(e.target.value)}
              ></textarea>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end">
            <div
              className="addModalButtons"
              style={{ marginTop: "20px", display: "flex", gap: "10px" }}
            >
              {/* <button className="addBtnCancel">Cancel</button> */}
              <button className="addBtnSave" onClick={handleSave}>
                Create Order
              </button>
            </div>
          </div>

          {/* customer type modal  */}
          <div>
            <Modal
              show={customershow}
              onHide={handleCustomerClose}
              centered
              className="addModal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Add Customer Type
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="categoryModalGrid">
                  <div>
                    <label>Customer Type</label>
                    <input
                      type="text"
                      placeholder="Enter Customer Type"
                      name="customerTypeName"
                      value={customerTypeName}
                      onChange={(e) => setCustomerTypeName(e.target.value)}
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="addBtnCancel"
                  type="button"
                  onClick={handleCustomerClose}
                >
                  Cancel
                </button>
                <button
                  className="addBtnSave"
                  type="submit"
                  onClick={handleCustomerSubmit}
                >
                  {" "}
                  Save
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};
